export const FETCH_APP_HOME = "FETCH_APP_HOME";
export const FETCH_APP_HOME_SUCCESS = "FETCH_APP_HOME_SUCCESS";
export const FETCH_APP_HOME_FAIL = "FETCH_APP_HOME_FAIL";

export const FETCH_TICKER = "FETCH_TICKER";
export const FETCH_TICKER_SUCCESS = "FETCH_TICKER_SUCCESS";
export const FETCH_TICKER_FAIL = "FETCH_TICKER_FAIL";
